export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14811.9136311c.jpg";